import React from 'react'
import { DotLoading } from 'antd-mobile'
import { useTranslation } from 'react-i18next';
import { LocalKeyMap } from '@/local';
type Style = {
  // 组件包裹层的额外样式
  style?: React.CSSProperties
  // 加载包裹层的额外样式
  loadingStyle?: React.CSSProperties
  // 加载文字的额外样式
  loadingTextStyle?: React.CSSProperties
  // 文字的额外样式
  textStyle?: React.CSSProperties
}

export type InfiniteScrollContentProps =  {
  hasMore: boolean
  loadingText?: string
  loadedText?: string
} & Style

const InfiniteScrollContent = (info: InfiniteScrollContentProps) => {
  const { t } = useTranslation();
  const {
    hasMore = false,
    style,
    textStyle,
    loadingStyle,
    loadingTextStyle,
    loadingText = t(LocalKeyMap['loading']),
    loadedText = `--- ${t(LocalKeyMap['emptyPage.noDate'])} ---`,
  } = info
  return (
    <div style={style}>
      {hasMore ? (
        <div style={loadingStyle}>
          <span style={loadingTextStyle}>{loadingText}</span><DotLoading></DotLoading>
        </div>
      ) : (
        <span style={textStyle}>{loadedText}</span>
      )}
    </div>
  )
}
export default InfiniteScrollContent